import type { TypeArticleWithoutUnresolvableLinksResponse } from '@/bb-contentful-types'
import type { Items } from '../utils/types/items'
import { sortArticlesByDate } from './articleUtils'

export const linkAsset = (data: Items, id: string) =>
  data?.includes?.Asset?.find((j) => {
    return j?.sys?.id === id
  })
export const linkEntry = (data: Items, id: string) => data?.includes?.Entry?.find((j) => j?.sys?.id === id)

export const linkDataAssetsAndEntry = (data: Items) => {
  if (data && data.items && data.includes) {
    const result = data.items.map((d) => {
      const image = linkAsset(data, d.fields?.image?.sys?.id)
      const heroImage = linkAsset(data, d.fields?.heroImage?.sys?.id)
      const seo = linkEntry(data, d.fields?.seo?.sys?.id)

      return { ...d, fields: { ...d.fields, image, heroImage, seo } }
    })

    return sortArticlesByDate(result as TypeArticleWithoutUnresolvableLinksResponse[])
  }

  return sortArticlesByDate(data?.items)
}
